<template>
    <div style="display: flex; flex-direction: column;position: relative" :class="showDialog && 'showDialog'" :style="{background:type==='0' ? '#F0F8FD' : '#F1F8F2'}">


        <div style="" class="person" >
            <van-image round width="60" height="60" :src="user.imageUrl" @click="gotoProfile"/>
            <div style="margin-left: 20px; display: flex; flex-direction: column; justify-content: space-around; align-items: flex-start">
                <div style="color: white; font-size: 18px; font-weight: bold;" @click="gotoProfile">{{user.userName || user.loginName}}
                </div>
                <div style="display: flex;" @click="gotoVerifyIDCard">
                    <div v-if="!user.userCard" style="background-color: #999999; color: white; font-size: 12px; margin-top: 2px; padding: 1px 5px; border-radius: 10px; margin-right: 10px;">未认证</div>
                    <div style="background-color: white; color: #1C7CF8; font-size: 12px; margin-top: 2px; padding: 1px 5px; border-radius: 10px">{{user.userCard ? '已认证' : '去认证'}}</div>
                </div>
            </div>
        </div>
        
        <div style="display: flex; flex-direction: column;position: relative;top: -40px;">
            <div class="card">
                <div v-for="(item,index) in cards" :key="index"
                     style="display: flex; flex-direction: column; align-items: center; width: 60px;"
                     @click="gotoItem(item)">
                    <van-image width="25" height="25" :src="item.src"
                               style="margin: 20px 0 10px 0"/>
                    <div style="color: #13181A; font-size: 14px; margin-bottom: 20px;">{{item.name}}</div>
                </div>
            </div>

            <div v-if="role() === '1'" class="line" >
                <div class="title">
                    分销员
                </div>
                <div class="flex">
                    <div v-for="(item,index) in distributors" :key="index"
                         style="display: flex; flex-direction: column; align-items: center;"
                         @click="gotoItem(item)">
                        <van-image width="30" height="30" :src="item.src"
                                   style="margin: 20px 0 6px 0"/>
                        <div style="color: #666666; font-size: 14px; margin-bottom: 20px;">{{item.name}}</div>
                    </div>
                </div>
            </div>

          <!-- 益宝普惠保险宣教员 -->
          <div class="line" style="margin-top: 25px;padding: 20px 0;">
              <div class="flex">
                  <van-image width="40" height="40" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20240826/2c92e840225b1bd3ee8f1c51f104753d.jpg"
                        />
                  <div>
                      <div style="font-size: 16px;font-weight: 600;">益宝普惠宣教员中心</div>
                      <div style="font-size: 12px;">传递保障价值，服务城乡居民</div>
                  </div>

                  <van-button type="info"  size="small" round @click="applyEnvoy">
                    去申请
<!--                      <wx-open-launch-weapp-->
<!--                          id="launch-btn"-->
<!--                          :path="this.miniProgramUrl"-->
<!--                      >-->
<!--                        <script type="text/wxtag-template">-->
<!--                        申请大使-->
<!--                        </script>-->
<!--                      </wx-open-launch-weapp>-->
                  </van-button>

              </div>
          </div>

          <!-- 我的家庭保障 -->
          <div class="line" style="margin-top: 25px;">
            <div class="title">
              我的家庭保障
            </div>
            <div class="flex">
              <div v-for="(item,index) in protection" :key="index"
                   style="display: flex; flex-direction: column; align-items: center;"
                   @click="gotoItem(item)">
                <van-image width="30" height="30" :src="item.src"
                           style="margin: 20px 0 6px 0"/>
                <div style="color: #666666; font-size: 14px; margin-bottom: 20px;">{{item.name}}</div>
              </div>
            </div>
          </div>

            <div class="line" >
                <div class="title">
                    我的邀请
                </div>
                <div class="flex">
                    <div v-for="(item,index) in invites" :key="index"
                         style="display: flex; flex-direction: column; align-items: center;"
                         @click="gotoItem(item)">
                        <van-image width="30" height="30" :src="item.src"
                                   style="margin: 20px 0 6px 0"/>
                        <div style="color: #666666; font-size: 14px; margin-bottom: 20px;">{{item.name}}</div>
                    </div>
                </div>
            </div>

            <div class="line-buttom">
                <div v-if="role() === '0'" class="row"  @click="becomeAmbassador">
                  <van-image width="30" height="27" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/29.png"
                             style="margin: 10px"/>
                   合作申请
                </div>
                <div class="row" @click="gotoCollection">
                  <van-image width="30" height="27" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/30.png"
                             style="margin: 10px"/>
                  我的收藏
                </div>
                <div class="row" @click="gotoCustomerService">
                  <van-image width="27" height="27" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/31.png"
                             style="margin: 10px"/>
                  联系客服
                </div>
                <div class="row"  @click="gotoAbout">
                  <van-image width="27" height="27" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/32.png"
                             style="margin: 10px"/>
                  关于我们
                </div>
            </div>

            <div @click="clickShequn" style="width: 90%;margin: 5px auto 0px;">
              <van-image src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/image.png" fit="cover" width="100%" height="100%"/>
            </div>

            <div style="width: 90%;margin: 5px auto 0px;">
              <van-image src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/H5%E6%88%91%E7%9A%84%E6%9C%80%E4%B8%8B%E6%96%B9.png" fit="cover" width="100%" height="100%"/>
            </div>
        </div>

 
        <div v-if="showDialog" class="cust-tips">
          <img style="object-fit: cover;width: 84vw" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/puhuibaoxian002.png"/>
          <div  @click="showDialog=false">
            关闭
          </div>
        </div>



    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image, Button,Dialog} from 'vant';
    import Cookies from 'js-cookie'
    import {isLogin} from '@/utils/commonUtils'
    import wx from 'weixin-js-sdk'; // 引入wxJS
    import {wxChatShare} from "@/utils/wxShare";

    Vue.use(Image).use(Button).use(Dialog);

    export default {
        name: "Me",
        data() {
            return {
                type: Cookies.get('type'),
                user: this.$store.state.user.user,
                miniProgramUrl:'',
                showDialog: false,
                cards: [
                    {name: '我的保单', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/18.png", to: '/myOrder'},
                    {name: '个人保险', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/19.png", to: '/orderList'},
                /*    {name: '理赔', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/20.png", to: '/claim'},*/
                    {name: '保障值', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/21.png", to: '/integral'},
                    {name: '我的体检', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/22.png", to: '/myCheck'},
                ],
                protection: [
                    {name: '添加我的家人', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/23.png", to: '/familyList'},
                    {name: '家人的保单', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/24.png", to: '/familyOrder'},
                    {name: '保障方案定制', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/25.png", to: '/protectionScheme'}
                ],
                invites: [
                    {name: '生成邀请卡', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/26.png", to: '/generateInvitation'},
                    {name: '已邀请', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/27.png", to: '/invited'},
                    {name: '我的爱心值', src: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/28.png", to: '/rank'}
                ],
                distributors: [
                    {name: '我的客户', src: require('@/assets/客户.png'), to: '/myClient'},
                    {name: '学习资料', src: require('@/assets/study.png'), to: '/study'},
                    {name: '推广达人', src: require('@/assets/share.png'), to: '/share'}
                ],
            }
        },
        created(){
          this.checkRole()

          this.initEnvoy()
        },
        methods: {
            checkRole() {
                if (isLogin()) { //未登录时不检测角色变化
                    // Dialog.alert({
                    //     className: 'custMsg',
                    //     message: '<img style="object-fit: cover;width: 99%;" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/puhuibaoxian002.png">',
                    // }).then(() => {
                    //     const dialog = document.querySelector('.van-dialog');
                    //     if (dialog) {
                    //         dialog.style.width = '99vw';
                    //     }
                    // });
                    this.showDialog = true

                    this.$axios.get("/ambassador/role", {params: {type: Cookies.get('type')}}).then(res => {
                        if (res.code == 200) {
                            this.$store.dispatch('UpdateRole', res.data.role)
                        }
                    });
                }
            },
            role() {
                return this.$store.state.user.role ? this.$store.state.user.role : '0'
            },
            gotoVerifyIDCard(){
                if (this.user.userCard) {
                    this.gotoProfile()
                }else{
                    this.$router.push('/editProfile')
                }
            },
            gotoLogin() {
                this.$router.push('/login')
            },
            gotoProfile() {
                this.$router.push('/profile')
            },
            gotoCollection() {
                this.$router.push('/collection')
            },
            gotoItem(item) {
                if (item.to === '/rank') {
                    window.location.href = `${process.env.VUE_APP_SHARE_URL}/rank`
                }else{
                    this.$router.push(item.to)
                }
            },
            gotoAbout() {
                this.$router.push('/about')
            },
            gotoCustomerService() {
                // window.location.href = 'http://wpa.qq.com/msgrd?v=3&uin=1718922859&site=qq&menu=yes'
                this.$router.push('/help')
            },
            becomeAmbassador() {
                this.$axios.get("/ambassador/validation", {params: {type: this.type}}).then(res => {
                    this.$router.push({path: '/applyAmbassador', query: {status: res.data.status}}) //status 0 正在审核中 1 审核通过 2 审核拒绝  3未申请
                });
            },
           clickShequn(){
              window.location.href='http://shequ.yibaojihua.com';
            },
           settingShare() {
              let name = this.user.userName || this.user.loginName
              let title = ' 向您推荐益+普惠保险综合服务平台'
              let param = {
                url: window.location.href.split('#')[0], // 当前页面url
                title: "【" + name + "】" + title, // 分享数据配置 主标题
                desc: '研究倡导 | 金融教育 | 产品研发 | 公益金融', // 分享数据配置 副标题
                link: process.env.VUE_APP_SHARE_URL + '/productList?shareId=' + this.user.userId + '&type=' + this.type, // 分享数据配置
                imgUrl: this.type === '0' ? 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/ce397ee056b9b80366696712a728d9e0.png' : 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/5c9842d2c40425dc8bc21f69f0c7c6f2.png', // 分享数据配置 －－ 全路径
                type: "link", // 分享类型,music、video或link，不填默认为link
                dataUrl: " ", // 如果type是music或video，则要提供数据链接，默认为空
              }
              wxChatShare(param);
            },
          initEnvoy(){
            try{
              window.axios.get(`mini-program/link`).then(res => {
                 this.miniProgramUrl = res.data
              })
            }catch (e) {
              console.log(e)
            }
          },
          //申请大使
           applyEnvoy(){
             /*wx.navigateToMiniProgram({
               appId: 'wxf16153326cef4648', // 要跳转的小程序 appId
               path: this.miniProgramUrl, // 打开的页面路径，如果为空则打开首页
               extraData: {}, // 需要传递给目标小程序的数据，目标小程序可在 App.onLaunch()，App.onShow() 中获取到这份数据
               success(res) {
                 // 打开成功
               }
             });*/

             window.open(this.miniProgramUrl, '_blank');

           },


        }
    }
</script>

<style scoped>

.person{
  background-image: url("https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/h5-person.png");
  width: 90%;
  height: 160px;
  background-position: center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  top: -20px;
}
    .card {
        margin: 0 20px;
        /*background: linear-gradient(270deg, rgba(64, 182, 248, 1) 0%, rgba(69, 135, 221, 1) 100%);*/
        background: white;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        box-shadow: 0px 10px #6EB4F5;

    }

    .line {
        background: white;
        box-shadow: 2px 2px 6px 2px rgba(219, 219, 219, 0.5);
        border-radius: 10px;
        margin: 15px 20px 0;
    }

    .flex {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .line-buttom {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 15px 10px 0;
      align-items: center;
      justify-content: flex-start;
      padding-right: 10px;
    }

    .row {
        height: 64px;
        line-height: 64px;
        color: #333333;
        font-size: 14px;
        width: calc(100%/2 - 10px);
        background: white;
        border-radius: 10px;
        margin-left: 10px;
        margin-bottom: 10px;
        text-align: center;
        display: flex;
         align-items: center;
        justify-content: center;
    }

    .title {
        align-self:start; margin: 20px 0 0 23px; text-align: start; font-size: 14px; font-weight: bolder;
    }

    .title::before {
        background-color: #1987F5;
        content: '';
        width: 3px;
        height: 14px;
        position: relative;
        right: 3px;
        top: 2px;
        display: inline-block;
    }

    .inclusive-envoy{

    }

    .cust-tips{
      position: absolute;
      top: 30%;
      left: 50%;
      //width: 99vw;
      //height: 80vh;
      overflow: auto;
      font-size: 16px;
      background-color: #fff;
      border-radius: 16px;
      transform: translate3d(-50%,-50%,0);
      z-index: 10;

    }

  .cust-tips div {
    width: 100%;
    line-height: 40px;
    height: 40px;
    text-align: center;
    background: #fff;
    color: #F76C6C;
    position: sticky;
    bottom: 0;
  }

  .showDialog::before{
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5); /* 半透明黑色遮罩 */
    z-index: 1; /* 低于绝对定位元素 */
    pointer-events: none; /* 允许点击穿透（不影响交互） */
    //display: none; /* 默认隐藏 */
  }

</style>
